module.exports = __webpack_public_path__ + "img/1096one3.f56cb71d.png";